module.exports = __webpack_public_path__ + "img/incidents-and-complaints.a86dcac6.svg";